import { AsyncPipe, NgClass, NgFor, NgSwitch, NgSwitchCase } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { RouterLink } from '@angular/router';
import { BackdropEventDirective } from '../../directives/backdrop-event/backdrop-event.directive';
import ProjectLinks from '../../project.links';
import { Toast, ToastMessageService } from '../toast-service/toast-service.service';

@Component({
  selector: 'app-toasts-container',
  templateUrl: './toasts-container.component.html',
  styleUrls: ['./toasts-container.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, NgFor, AsyncPipe, NgbToastModule, NgSwitch, NgSwitchCase, RouterLink, TranslateModule],
  hostDirectives: [
    {
      directive: BackdropEventDirective,
      outputs: ['clickedOnBackdrop'],
    },
  ],
  host: {
    class: 'toast-container position-fixed end-0 p-3',
    style: 'z-index: 1200; top: 5rem',
    '(clickedOnBackdrop)': 'clearAll()',
  },
})
export class ToastsContainerComponent {
  public readonly REGISTRATION_LINK: string = ProjectLinks.LINK_REGISTRATION;

  private readonly toastService: ToastMessageService = inject(ToastMessageService);

  public readonly toasts$: Observable<Toast[]> = this.toastService.toasts$;

  public remove(toast: Toast): void {
    this.toastService.remove(toast);
  }

  public clearAll(): void {
    this.toastService.clearAll();
  }
}
